import * as React from 'react';
export const unionSvg = React.forwardRef(function unionSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.162 25.821c3.931.7 8.246-1.517 8.246-7.295v-7.062c-4.794.525-5.561 3.443-5.609 6.536v3.21c0 3.035-1.246 4.203-2.637 4.611Z',
      fill: '#E60000',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.454 24.513c-.91-.175-3.643-1.05-3.643-6.595V5.662c2.828 0 5.561 1.576 5.561 6.187v7.295c0 1.926.048 3.56.72 4.027-.48.992-1.679 1.518-2.638 1.342Z',
      fill: '#E60000',
    }),
  );
});
unionSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var union = {
  category: 'brand',
  colorable: false,
  name: 'union',
  svg: unionSvg,
};
